import { useRef } from "react";
import { useGetMaxHeightOnResize } from "./helpers/useGetMaxHeightOnResize";
const defaultOptions = {
    disableSync: false,
};
/**
 * Synchronize labels height across provided fields to match the highest label height
 * This will align the fields in the same row in the form
 */
export function useSyncFieldsLabels(fieldContainersRefs, options = defaultOptions) {
    const lastMaxHeightRef = useRef(0);
    const mapFieldRefToHtmlLabel = (ref) => {
        if (!ref.current) {
            return;
        }
        const refElementIsFormField = ref.current.dataset.formField;
        if (!refElementIsFormField) {
            throw new Error("Provided element is not FormField components");
        }
        const htmlLabel = ref.current.querySelector("label");
        const labelHasChildren = htmlLabel?.children.length > 0;
        if (!labelHasChildren) {
            throw new Error("FormField component do not have <label> with at least one child");
        }
        return htmlLabel;
    };
    const htmlLabels = fieldContainersRefs.map(mapFieldRefToHtmlLabel).filter(Boolean);
    const maxHeight = useGetMaxHeightOnResize(htmlLabels);
    const isMaxHeightChanged = maxHeight !== lastMaxHeightRef.current;
    const syncLabels = () => {
        lastMaxHeightRef.current = maxHeight;
        htmlLabels.forEach((label) => {
            label.style.height = `${maxHeight}px`;
            label.style.alignItems = "flex-end";
        });
    };
    const resetLabels = () => {
        lastMaxHeightRef.current = 0;
        htmlLabels.forEach((label) => {
            if (label.style.height) {
                label.style.height = "";
                label.style.alignItems = "center";
            }
        });
    };
    if (isMaxHeightChanged && !options.disableSync) {
        syncLabels();
    }
    if (options.disableSync) {
        resetLabels();
    }
    return null;
}
//# sourceMappingURL=useSyncFieldsLabels.js.map